export const vkApiIframePath = '/iframe/vk-api'
